import { Button, Card, CardBody, CardHeader, FormGroup, Table } from 'reactstrap';
import { CoreGoogleDeviceExportConfiguration, GoogleDeviceOrganizationalUnitSource } from '../../../../../../models/CoreGoogleDeviceExportModels';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GoogleDeviceOrganizationalUnitSettings from './GoogleDeviceOrganizationalUnitSettings'
interface GoogleDeviceExportConfigurationProps {
    disabled: boolean
    configuration: CoreGoogleDeviceExportConfiguration
    active:boolean
    updatePart: (part: Partial<CoreGoogleDeviceExportConfiguration>) => void
    onValidChange: (arg: boolean) => void
}

export const validator = (configuration: CoreGoogleDeviceExportConfiguration, active:boolean) => {
    const validation: string[] = [];

    if (active === true) {
        if (configuration.organizationalUnitSettings.organizationalUnitSource !== null
            && configuration.organizationalUnitSettings.organizationalUnitSource === GoogleDeviceOrganizationalUnitSource.None) {
            validation.push('organizationalUnitSource')
        }

        if (configuration.organizationalUnitSettings.organizationalUnitSource === GoogleDeviceOrganizationalUnitSource.ValueBuilder
        && configuration.organizationalUnitSettings.stringValueBuilderParts.length === 0) {
            validation.push('requiredValueBuilderParts')
        }
    }
    return validation;
}
export const warningMessages = (originalConfiguration: CoreGoogleDeviceExportConfiguration, updatedConfiguration: CoreGoogleDeviceExportConfiguration) => {
    const warnings: string[]= [];

    return warnings;
}
const GoogleDeviceExportConfiguration = (props: GoogleDeviceExportConfigurationProps) => {
    const { t } = useTranslation(['configuration', 'common', 'device']);
    const [open, setOpen] = useState<boolean>(true);

    const validation = validator(props.configuration, props.active);  
    useEffect(() => {
        props.onValidChange(validation.length ? true : false)
    }, [props.configuration]);
    return (
        <Card className="edit-module">
            <CardHeader>
                <Button outline color="secondary" style={{ width: '37px', float: 'right' }} onClick={() => setOpen(!open)}>{open ? '-' : '+'}</Button>
                {t('modules.GoogleDeviceExport.title', { ns: 'common' })}
            </CardHeader>
            <CardBody>
                <div style={{ margin: '1rem 0' }} >

                    <GoogleDeviceOrganizationalUnitSettings
                        disabled={props.disabled}
                        onChange={x => props.updatePart({ organizationalUnitSettings: x })}
                        organizationalUnitSettings={props.configuration.organizationalUnitSettings}
                        validation={validation}
                    />
                </div>

            </CardBody>
        </Card>


    )

}
export default GoogleDeviceExportConfiguration;